"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../analytics");
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
class AnalyticsServiceMaacIE extends _analytics.AnalyticsService {
  constructor(config) {
    super(config);
    this.TAGGING_ID_PREFIX = 'product_multi_view';
    this.questionsAnswers = [];
  }
  endJourney(_ref) {
    let {
      businessSolutionId
    } = _ref;
    console.log(`Selected business solution ID ${businessSolutionId}`);
  }
  _composeTaggingPageName(suffix) {
    return `${this.TAGGING_ID_PREFIX}:solution tool:${suffix}`;
  }
  _composeTaggingViewEvent(_ref2) {
    let {
      newPageName,
      newStepIndex,
      eventLabel
    } = _ref2;
    return {
      taggingId: `${this.TAGGING_ID_PREFIX}_${newStepIndex}`,
      taggingType: 'view',
      page_name: newPageName || `step${newStepIndex}`,
      page_channel: 'Business',
      page_section: 'eshop',
      page_subsection: 'solutions tool',
      page_type: 'solutions',
      page_environment: 'Web',
      journey_type: 'journey',
      event_category: 'tools',
      event_label: eventLabel || `step${newStepIndex}`
    };
  }
  _composeTaggingActionEvent(_ref3) {
    let {
      newPageName,
      eventLabel,
      newStepIndex
    } = _ref3;
    return {
      ...this._composeTaggingViewEvent({
        newPageName,
        newStepIndex
      }),
      event_name: 'ui_interaction',
      event_category: 'users',
      event_action: 'click',
      event_label: eventLabel,
      taggingType: 'link'
    };
  }
  _composeAnswersTagging(_ref4) {
    var _currentQuestion$tagg, _this$questionsAnswer, _this$questionsAnswer2;
    let {
      newStepIndex,
      currentQuestion
    } = _ref4;
    const answers = {};
    const selections = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg === void 0 ? void 0 : _currentQuestion$tagg.selections;
    ((_this$questionsAnswer = this.questionsAnswers) === null || _this$questionsAnswer === void 0 ? void 0 : _this$questionsAnswer[newStepIndex]) && (answers[selections] = (_this$questionsAnswer2 = this.questionsAnswers[newStepIndex]) === null || _this$questionsAnswer2 === void 0 ? void 0 : _this$questionsAnswer2.join(' | '));
    return answers;
  }
  _composeAnswers(_ref5) {
    let {
      eventName,
      currentQuestion,
      selectedOptionEvent,
      newStepIndex,
      eventLabel,
      newPageName
    } = _ref5;
    if (eventName === 'onToolBack') {
      return {};
    }
    if (selectedOptionEvent !== null && selectedOptionEvent !== void 0 && selectedOptionEvent.length) {
      var _this$questionsAnswer3;
      this.questionsAnswers[newStepIndex] = selectedOptionEvent;
      const lastAnswer = (_this$questionsAnswer3 = this.questionsAnswers[newStepIndex]) === null || _this$questionsAnswer3 === void 0 ? void 0 : _this$questionsAnswer3.join(' | ');
      if (eventName === 'onToolAnswer' && (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) === 'choices' && lastAnswer) {
        return {
          ...this._composeTaggingViewEvent({
            newPageName,
            newStepIndex
          }),
          event_name: 'ui_interaction',
          event_category: 'users',
          event_action: 'click',
          event_label: eventLabel,
          taggingType: 'link',
          selections: lastAnswer
        };
      }
    }
  }
  composeTaggingEvents(_ref6) {
    let {
      pageName,
      eventLabel,
      stepIndex,
      productName,
      eventName,
      selectedOptionEvent,
      currentQuestion
    } = _ref6;
    const newStepIndex = stepIndex;
    const newPageName = pageName ? `${this.TAGGING_ID_PREFIX}:${pageName}` : `${this.TAGGING_ID_PREFIX}:solutions tool:step${newStepIndex}`;
    const events = super.composeTaggingEvents({
      newPageName,
      eventLabel,
      stepIndex: newStepIndex
    });
    const eventActionTag = this._composeTaggingActionEvent({
      newStepIndex,
      eventName,
      currentQuestion
    });
    const eventViewTag = this._composeTaggingViewEvent({
      newPageName,
      eventLabel,
      newStepIndex
    });
    return {
      ...events,
      onToolStart: {
        ...eventViewTag,
        event_name: 'tool_start'
      },
      onToolView: {
        ...eventViewTag,
        event_name: 'tool_view'
      },
      onToolCheckout: {
        ...eventActionTag,
        link_name: super._composeTaggingActionLinkName({
          prefix: `${this.TAGGING_ID_PREFIX}:solutions tool:${pageName}`,
          action: 'Next'
        }),
        product_name: [productName],
        product_category: ['DS'],
        product_id: ['tool']
      },
      onToolEnd: {
        ...eventViewTag,
        event_name: 'tool_end'
      },
      onToolResult: {
        ...eventViewTag,
        event_name: 'tool_success',
        product_name: [productName],
        product_category: ['DS'],
        product_id: ['tool']
      },
      onToolResultTabSwitch: {
        ...eventViewTag,
        event_name: 'tool_success',
        product_name: [productName],
        product_category: ['DS'],
        product_id: ['tool']
      },
      onToolNext: {
        ...eventActionTag,
        link_name: super._composeTaggingActionLinkName({
          prefix: `${this.TAGGING_ID_PREFIX}:solutions tool:step${newStepIndex}`,
          action: 'Next'
        }),
        ...this._composeAnswersTagging({
          newStepIndex,
          currentQuestion
        })
      },
      onToolBack: {
        ...eventActionTag,
        link_name: super._composeTaggingActionLinkName({
          prefix: `${this.TAGGING_ID_PREFIX}:solutions tool:step${newStepIndex}`,
          action: 'Back'
        })
      },
      onToolRestart: {
        ...eventActionTag,
        link_name: super._composeTaggingActionLinkName({
          prefix: `${this.TAGGING_ID_PREFIX}:solutions tool:step${newStepIndex}`,
          action: 'Restart'
        })
      },
      onToolShare: {
        ...eventActionTag,
        link_name: super._composeTaggingActionLinkName({
          prefix: `${this.TAGGING_ID_PREFIX}:solutions tool:step${newStepIndex}`,
          action: 'Share'
        })
      },
      onToolAnswer: {
        ...eventActionTag,
        ...this._composeAnswers({
          eventName,
          currentQuestion,
          selectedOptionEvent,
          newStepIndex,
          eventLabel,
          newPageName
        })
      }
    };
  }
  getEventsName(questionIndex) {
    const eventMap = {
      1: 'onToolStart',
      2: 'onToolView'
    };
    return {
      [_questionnaireActions.SET_VIEW_QUESTION_TAGS]: {
        eventName: eventMap[questionIndex] || 'onToolEnd'
      },
      [_questionnaireActions.GOTO_NEXT_QUESTION]: {
        eventName: 'onToolNext'
      },
      [_questionnaireActions.GOTO_PREVIOUS_QUESTION]: {
        eventName: 'onToolBack'
      },
      [_questionnaireActions.RESET_QUESTIONNAIRE]: {
        eventName: 'onToolRestart'
      },
      [_questionnaireActions.ADD_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REPLACE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REMOVE_SELECTION]: {
        eventName: 'onToolAnswer'
      }
    };
  }
  getQuestionnaireEventData(currentViewQuestionIndex) {
    return {
      pageName: '',
      stepIndex: currentViewQuestionIndex + 1
    };
  }
}
var _default = AnalyticsServiceMaacIE;
exports.default = _default;